var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticStyle:{"font-size":"15px"},attrs:{"id":"label","options":_vm.labels,"label":"name","multiple":true,"placeholder":"Type"},on:{"input":_vm.filterTable},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2541a9f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/LabelsFilter.vue
// module id = 724
// module chunks = 0